import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { AvForm, AvGroup, AvInput, AvFeedback } from 'availity-mobx-reactstrap-validation';

import { validatePhoneNumber, validateFullName } from 'js/services/Regex';

import Modal from 'js/components/core/Modal';
import SubmitRow from 'js/components/core/Modal/SubmitRow';

import StepStatus from 'js/components/core/SteppedPage/StepStatus';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';

import Container from './Container';
import Title from './Title';
import SubTitle from './SubTitle';
import FormBody from './FormBody';
import CheckIcon from './CheckIcon';
import AppState from "js/stores/AppState";
import userCountry from 'js/services/UserCountry';

@inject('page')
@observer
export default class UserInfo extends Component {
  closeModal = () => window.history.back();

  submitted = () => {
    const page = this.props.page;
    let flowContext = AppState.currentPage === 'CheckoutPage' ? 'buyer' : 'seller';

    analytics.track(`CTA_BP_buyer_checkout_info_confirm`, {
      'Item id': page.alias,
      'Item Price': page.item.price,
      'Item Name': page.item.title,
      'Item Size': page.size,
      'Payment Link': page.item.checkout_url,
      'Event Initiated by': flowContext
    })
    page.nextStep();
  }

  render() {
    const page = this.props.page;
    return (
      <Modal showModal onCancel={this.closeModal} withCloseButton={!page.isSubmitting}>
        <Container>
          <AvForm onValidSubmit={this.submitted}>
            <CheckIcon />
            <Title>Confirm information</Title>
            <SubTitle>We need some information to keep you updated with your item status.</SubTitle>

            <FormBody>
              <AvGroup>
                <AvInput
                  type="text"
                  name="full_name"
                  placeholder="Full Name"
                  autoComplete="name"
                  value={page.full_name}
                  onChange={page.setFullName}
                  required
                  validate={validateFullName}
                  Title="Please enter your full name"
                />
                <AvFeedback>Please enter a last name.</AvFeedback>
              </AvGroup>

              <AvGroup>
                <AvInput
                  name="phone_number"
                  type={userCountry() === 'NG' ? 'text' : 'tel'}
                  autoComplete="tel"
                  placeholder="Enter your phone number"
                  value={page.phone_number}
                  onChange={page.setPhoneNumber}
                  required
                  validate={validatePhoneNumber}
                />
                <AvFeedback>Please provide your phone number.</AvFeedback>
              </AvGroup>
            </FormBody>

            <SubmitRow>
              <ContinueButton autoFocus>Confirm</ContinueButton>
              <StepStatus />
            </SubmitRow>
          </AvForm>
        </Container>
      </Modal>
    );
  }
}
